import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionFiveImagesFifteenTextsBody,
    SectionFiveImagesFifteenTextsDetails,
} from "types/api/blocks/sectionFiveImagesFifteenTexts";

function useSectionFiveImagesFifteenTextsApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionFiveImagesFifteenTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionFiveImagesFifteenTextsDetails> => {
        return get<PathParamsWithId, undefined, SectionFiveImagesFifteenTextsDetails>({
            url: "/blocks/section-five-images-fifteen-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionFiveImagesFifteenTexts = React.useCallback((body: SectionFiveImagesFifteenTextsBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionFiveImagesFifteenTextsBody, null>({
            url: "/blocks/section-five-images-fifteen-texts",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionFiveImagesFifteenTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-five-images-fifteen-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionFiveImagesFifteenTexts,
        saveSectionFiveImagesFifteenTexts,
        deleteSectionFiveImagesFifteenTexts
    };
}

export default useSectionFiveImagesFifteenTextsApi;